import { Controller } from 'stimulus'
import i18nSetup from "../i18n-setup"
import Pikaday from 'pikaday'
import * as moment from 'moment'

export default class datePickerController extends Controller {
  static targets = [ 'input', 'inputHidden', 'form']

  initialize() {
    this.i18n = i18nSetup()
    this.inputTarget.value = moment(this.inputHiddenTarget.value, 'YYYY-MM-DD').format(this.i18n.t('web.javascript.datepicker.format'));
    $(this.inputTarget).mask('00/00/0000')
  }

  connect() {
    const picker = new Pikaday({
      field: this.inputTarget,
      format: this.i18n.t('web.javascript.datepicker.format'),
      yearRange: [1900, moment().year()],
      maxDate: moment().toDate(),
      i18n: {
        previousMonth : this.i18n.t('web.javascript.datepicker.previous_month'),
        nextMonth     : this.i18n.t('web.javascript.datepicker.next_month'),
        months        : this.i18n.t('web.javascript.datepicker.months'),
        weekdays      : this.i18n.t('web.javascript.datepicker.weekdays'),
        weekdaysShort : this.i18n.t('web.javascript.datepicker.weekdays_short'),
      },
    })
  }

  checkValidity() {
    if( this.inputTarget.value &&
        !moment(this.inputTarget.value, this.i18n.t('web.javascript.datepicker.format')).isValid()) {
      this.inputTarget.setCustomValidity(this.i18n.t('web.javascript.datepicker.validation_message'))
    } else {
      this.inputTarget.setCustomValidity('')
    }
  }

  parseDate() {
    if(this.inputTarget.value) {
      this.inputHiddenTarget.value = moment(this.inputTarget.value, this.i18n.t('web.javascript.datepicker.format')).format('YYYY-MM-DD')
    } else {
      this.inputHiddenTarget.value = ""
    }
  }
}
